<template>
  <component
    :is="componentIs"
    tabindex="0"
    :to="to"
    :href="href"
    :target="computedTarget"
    class="button button--v3"
    :class="classes"
    :style="style"
    :disabled="disabled"
    @click="click"
    @keypress.enter.exact="click"
    @keypress.space.exact="click"
  >
    <span
      class="button__text"
      :class="{
        'button__text--hidden': loading,
        'button__text--bold': textBold,
        'button__text--uppercase': textUppercase,
      }"
    >
      {{ text }}
    </span>
    <LoaderDualRings
      v-show="loading"
      class="button__loader"
      :total-size="2"
      :internal-ring-size="1.4"
      :internal-ring-color="color"
      :external-ring-size="2"
      :external-ring-color="color"
    />
  </component>
</template>

<script>
import ButtonMixin from '../../mixins/buttons'

export default {
  mixins: [ButtonMixin],
  data: () => ({
    CLASS_BASE: 'button--v3',
  }),
}
</script>

<style lang="scss" scoped>
@import "~assets/css/variables";

.button {
  cursor: pointer;
  position: relative;
  font-family: $font-family__oswald;
  font-weight: normal;
}

.button--v3 {
  color: white;
  padding: 5px 10px;
  border-radius: 8px;
  text-decoration: none;
  box-shadow: 0 0.2rem 0.2rem rgba(0, 0, 0, 0.5);

  &:not(.button--v3--no-focus):hover {
    color: white;
    box-shadow: 0 0 1rem black;
  }
  &:not(.button--v3--no-focus):active {
    box-shadow: 0 0 0.2rem white inset;
  }
  &.button--v3--disabled {
    opacity: 0.65;
    cursor: default;
    cursor: not-allowed;

    &:active, &:hover {
      box-shadow: none;
    }
  }
}

.button--v2--no-padding {
  padding: 0;
}

.button--v3--full-width {
  width: 100%;
  text-align: center;
}

.button__text--hidden {
  visibility: hidden;
}
.button__text--uppercase {
  text-transform: uppercase;
}
.button__text--bold {
  font-weight: 800;
}

.button__loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
